import Blue from "~/core";

new Blue({
	name: 'Read More - Text Truncation',
	selector: ".truncate-read-more",
	setup(textEl) {
		const limit = parseInt(textEl.getAttribute("data-truncate-limit")) || 100; // set default of 100 character limit is data attribute not set
		let string = textEl.textContent;
		const originalString = textEl.textContent; // store original text value to show on Read More click or if screen is resized above small breakpoint
		const smBreakpoint = 576;

		if (string.length > limit) {
			let currentWindowWidth = window.innerWidth;
			let readMoreLink = document.createElement("a");
			readMoreLink.setAttribute("href", "");
			readMoreLink.textContent = "Read More";
			readMoreLink.style.display = "none";
			readMoreLink.style.marginBottom = "1.25rem";
			textEl.insertAdjacentElement('afterend', readMoreLink);

			const truncateText = () => {
				string = string.slice(0, limit);
				let words = string.split(" ");
				textEl.textContent = "";
				words.forEach((w, i) => {
					if (i < words.length - 1) {
						textEl.textContent += w + " ";
					}
				});
				let span = document.createElement("span");
				span.style.whiteSpace = "nowrap";
				span.textContent = words[words.length - 1] + "...";
				textEl.insertAdjacentElement('beforeend', span);
			}
			const returnText = () => {
				textEl.innerHTML = "";
				textEl.textContent = originalString;
			}

			const readMoreClickHandler = (e) => {
				e.preventDefault();
				returnText();
				readMoreLink.textContent = "Read Less";
			}
			const readLessClickHandler = (e) => {
				e.preventDefault();
				truncateText();
				readMoreLink.textContent = "Read More";
			}

			this.$addEvents(readMoreLink, "click.prevent", (e) => {
				if (readMoreLink.textContent === "Read More") readMoreClickHandler(e);
				else readLessClickHandler(e);
			});

			// truncate text on page load if screen is small
			if (window.innerWidth < smBreakpoint) {
				truncateText();
				readMoreLink.style.display = "block";
			}

			// if window resize passes small breakpoint threshold, truncate or return original text accordingly
			this.$addEvents(window, "resize", () => {
				let newWindowWidth = window.innerWidth
				if (currentWindowWidth > smBreakpoint && newWindowWidth <= smBreakpoint) {
					truncateText();
					readMoreLink.style.display = "block";
				}
				else if (currentWindowWidth<= smBreakpoint && newWindowWidth > smBreakpoint) {
					returnText();
					readMoreLink.style.display = "none";
				}
				currentWindowWidth = newWindowWidth;
			});
		}
	}
});